export default __webpack_public_path__ + "static/media/memoir.449f2ea6.svg";